import React from 'react';
import AchievementNotification from './AchievementNotification';
import { useNotifications } from '../context/NotificationContext';
import './NotificationContainer.css';

const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotifications();

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <AchievementNotification
          key={notification.id}
          achievement={notification.achievement}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;